import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch } from '../index'
import type { RootState } from '../slices/reducers'
import {
  getAllBuildingFavorites,
  createBuildingFavorite,
  deleteBuildingFavorite,
  clearError,
  clearBuildingFavorites,
} from '../slices/enhancedFavoritesSlice'
import type { CreateBuildingFavoriteRequest } from '@popety-io/types'

export const useBuildingsFavorites = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { buildingFavorites, loading, error } = useSelector(
    (state: RootState) => state.enhancedFavorites
  )

  const actions = {
    getAllBuildingFavorites: () => dispatch(getAllBuildingFavorites()),
    createBuildingFavorite: (favoriteData: CreateBuildingFavoriteRequest) =>
      dispatch(createBuildingFavorite(favoriteData)),
    deleteBuildingFavorite: (id: string) =>
      dispatch(deleteBuildingFavorite(id)),
    clearError: () => dispatch(clearError()),
    clearBuildingFavorites: () => dispatch(clearBuildingFavorites()),
  }

  const selectors = {
    getFavoriteByBuildingId: (buildingId: string) =>
      buildingFavorites.find(
        (fav) => fav.building_id === String(buildingId) && fav.active
      ),
    isBuildingFavorited: (buildingId: string) =>
      buildingFavorites.some(
        (fav) => fav.building_id === String(buildingId) && fav.active
      ),
    getFavoritesByUserId: (userId: string) =>
      buildingFavorites.filter((fav) => fav.user_id === userId && fav.active),
    getSharedFavorites: () =>
      buildingFavorites.filter((fav) => fav.shared && fav.active),
  }

  return {
    // State
    buildingFavorites,
    loading,
    error,
    // Actions
    ...actions,
    // Selectors
    ...selectors,
  }
}
